module.exports = __webpack_public_path__ + "img/novydvor_sidebar.80c7363b.jpg";